import { render } from "./EditTextbook.vue?vue&type=template&id=51908a0b&scoped=true"
import script from "./EditTextbook.vue?vue&type=script&lang=js"
export * from "./EditTextbook.vue?vue&type=script&lang=js"

import "./EditTextbook.vue?vue&type=style&index=0&id=51908a0b&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-51908a0b"]])

export default __exports__